import React from 'react'
import { useNextOccurrencesCore } from '../hooks/use-next-occurrences-core'
import { NextOccurrencesPreview as View } from './next-occurrences-preview'
import { ISchedulableLike } from '../types'

export interface INextOccurrencesFromScheduleProps {
  scheduleLike: ISchedulableLike
  title?: string
  maxCount?: number
  emptyMessage?: string
}

export const NextOccurrencesFromSchedule: React.FC<INextOccurrencesFromScheduleProps> = ({
  scheduleLike,
  title,
  maxCount,
  emptyMessage,
}) => {
  const { occurrences, loading, currTz } = useNextOccurrencesCore({ schedule: scheduleLike })
  return (
    <View
      occurrences={occurrences}
      tz={currTz}
      loading={loading}
      title={title}
      maxCount={maxCount}
      emptyMessage={emptyMessage}
    />
  )
}
